module.exports = __webpack_public_path__ + "img/elementheights_jaka.6b19191e.png";